import { WebinarStatus } from 'models/webinar-status.enum';
import { Tag } from 'primereact/tag';
import { memo, PropsWithChildren } from 'react';

interface ComponentProps {
  status: WebinarStatus;
}

const WebinarStatusTag = ({ status }: PropsWithChildren<ComponentProps>) => {
  switch (status) {
    case WebinarStatus.SCHEDULED: {
      return (<Tag value={status}/>);
    }
    case WebinarStatus.STARTED: {
      return (<Tag value={status} severity="info"/>);
    }
    case WebinarStatus.FINISHED: {
      return (<Tag value={status} severity="success"/>);
    }
    case WebinarStatus.CANCELLED: {
      return (<Tag value={status} severity="danger"/>);
    }
    default: {
      return (<>{status}</>);
    }
  }
};

export default memo(WebinarStatusTag, (prevProps, nextProps) => {
  return prevProps.status === nextProps.status;
});